import { FacilityId, PrefectureId } from '@gyym/sdk'

import { getPrefectureSlugById } from '@/modules/Prefectures/actions'

/**
 * Format city code as used in URLs (5 digits, zero padded)
 */
export const formatCityCode = (cityCode: number | string): string =>
  `${cityCode}`.padStart(5, '0')

export const buildFacilityLink = ({
  id,
  cityCode: rawCityCode,
  prefectureId,
}: {
  id: FacilityId
  cityCode: number
  prefectureId: PrefectureId
}) => {
  const prefectureSlug = getPrefectureSlugById(prefectureId)
  const cityCode = formatCityCode(rawCityCode)

  const href = {
    pathname:
      '/facilities/prefectures/[prefectureSlug]/cities/[cityCode]/facilities/[facilityId]',
    query: {
      prefectureSlug,
      cityCode,
      facilityId: id,
    },
  }

  const as = `/facilities/${prefectureSlug}/C${cityCode}/${id}`

  return { href, as }
}
